import { StyledPin } from './Pin'

export default StyledPin
